/**
 * @generated SignedSource<<2d9c41ef05c759efd3fca9b7e19e6ffa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addCollageRulePanel_ProductNameQuery$variables = {
  id: string;
};
export type addCollageRulePanel_ProductNameQuery$data = {
  readonly node: {
    readonly name?: string;
  } | null;
};
export type addCollageRulePanel_ProductNameQuery = {
  response: addCollageRulePanel_ProductNameQuery$data;
  variables: addCollageRulePanel_ProductNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Model",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addCollageRulePanel_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "addCollageRulePanel_ProductNameQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ba80d303c8a130f4007a7ce30a6ed3d",
    "id": null,
    "metadata": {},
    "name": "addCollageRulePanel_ProductNameQuery",
    "operationKind": "query",
    "text": "query addCollageRulePanel_ProductNameQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Model {\n      name\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "30f33a4cbaedfcf4d2f072af334a040b";

export default node;
